const createQuery = () => `
  ... on CompanyProfileWidget {
    id
    latestArticle {
      _id
      headline
      fullUrlPath
      contentType
      subContentType
      sell
      images {
        thumbnail_widescreen_553 {
          url
        }
      }
    }
  }
`

export default createQuery
